import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { LocaService } from '../../../service/loca/loca.service';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { getCreateFormRequest } from '../../../util/util';
import { CreateFormService } from '../../../service/create-form/create-form.service';

declare const cwebclient:any;

@Component({
  selector: 'app-root',
  templateUrl: 'wa9120.component.html',
  styleUrls: ['wa9120.component.scss']
})
export class Wa9120Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9120:ロケーションマスタ照会';
  public updprogramCd = 'WA9120';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  private tabIndex = 0;

  private isEnableClearFilter = null;

  //tab1 grid
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isShowDeleteModal = false;
  private isShowPrintModal = false;

  private isShowSendLoading = false;

  private isShowWa9122 = false;
  private isShowWa9125 = false;
  private isShowWa9124 = false;
  private isShowWa9121 = false;
  private isShowWa9183 = false;

  private editNode = null;
  private bkgFilter = null;

  private isRefreshAndCheckNewData = false;
  private isRefreshAndCheckUpdateData = false;

  private deleteErrorMsgForPopup = null;
  private reportOpened = false;


  constructor(
    private router: Router,
    private locaService: LocaService,
    private clientReportService: ClientReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private createFormService: CreateFormService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      suppressRowClickSelection: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9120_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '',
        filter: 'text',
        unSortIcon: false,
        suppressMenu: true,
        width: 100,
        cellClass: ['tc', 'cellclass'],
        pinned: 'left',
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '修正',
          onClick: this.onEditButtonClick.bind(this)
        }
      },
      {
        headerName: 'ロケーション',
        field: 'locaCd',
        sort: 'asc',
        width: this.getColumnWidth('locaCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        width: this.getColumnWidth('locaTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーションバーコード',
        field: 'locabarcodeTx',
        width: this.getColumnWidth('locabarcodeTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '倉庫コード',
        field: 'whCd',
        width: this.getColumnWidth('whCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フロアコード',
        field: 'floorCd',
        width: this.getColumnWidth('floorCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'エリアコード',
        field: 'areaCd',
        width: this.getColumnWidth('areaCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '列コード',
        field: 'lineCd',
        width: this.getColumnWidth('lineCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '棚コード',
        field: 'shelfCd',
        width: this.getColumnWidth('shelfCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '段コード',
        field: 'layerCd',
        width: this.getColumnWidth('layerCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '番コード',
        field: 'orderCd',
        width: this.getColumnWidth('orderCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '温度帯区分',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品カテゴリ',
        field: 'typeitemTx',
        width: this.getColumnWidth('typeitemTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケブロック',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケABC',
        field: 'locaabcTx',
        width: this.getColumnWidth('locaabcTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '格納什器ケース名',
        field: 'shelfcaseTx',
        width: this.getColumnWidth('shelfcaseTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷優先順位',
        field: 'arrivepriorityNr',
        width: this.getColumnWidth('arrivepriorityNr', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷優先順位',
        field: 'shippriorityNr',
        width: this.getColumnWidth('shippriorityNr', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷不可フラグ',
        width: this.getColumnWidth('notarriveTx', 120),
        valueGetter: function notarriveTx(params) {
          return params.data.notarriveFl ? '入荷不可' : '入荷可';
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷不可フラグ',
        width: this.getColumnWidth('notshipTx', 120),
        valueGetter: function notshipTx(params) {
          return params.data.notshipFl ? '出荷不可' : '出荷可';
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品混載可フラグ',
        field: 'mixitemFl',
        width: this.getColumnWidth('mixitemTx', 160),
        valueGetter: function mixitemTx(params) {
          return params.data.mixitemFl ? '商品混載可' : '商品混載不可';
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット混載可フラグ',
        field: 'mixlotFl',
        width: this.getColumnWidth('mixlotTx', 160),
        valueGetter: function mixlotTx(params) {
          return params.data.mixlotFl ? 'ロット混載可' : 'ロット混載不可';
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限混載可フラグ',
        field: 'mixuselimitFl',
        width: this.getColumnWidth('mixuselimitTx', 160),
        valueGetter: function mixlotTx(params) {
          return params.data.mixuselimitFl ? '使用期限混載可' : '使用期限混載不可';
        },
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '備考',
        field: 'memoTx',
        width: this.getColumnWidth('srclocaCd', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9120_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9120_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9120_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    this.gridHelper.el = this.gridView;
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    //画面初期表示時はセッションクリア
    sessionStorage.removeItem('wa9120_filterModel');
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.locaService
      .get()
      .then(outputJson => {
        if (this.tabIndex === 0) {
          this.rowData = outputJson.locas;
        }

        if (this.isRefreshAndCheckNewData == true && this.rowData != null && this.rowData.length > 0) {
          var latestDateStr = null;
          this.rowData.forEach((v, k) => {
            if (latestDateStr == null) {
              latestDateStr = v['addDt'];
            } else {
              var latestDate = new Date(Date.parse(latestDateStr.replace(/-/g, '/')));
              var curDate = new Date(Date.parse(v['addDt'].replace(/-/g, '/')));
              if (curDate.getTime() > latestDate.getTime()) {
                latestDateStr = v['addDt'];
              }
            }
          });
          setTimeout(() => {
            this.gridOptions.api.forEachNode(node => {
              if (node.data['addDt'] === latestDateStr) this.gridHelper.prepareSelectedAnimateByNodes([node]);
            });
            this.gridHelper.selectedAnimateDelay();
          }, 100);
        }

        setTimeout(() => {
          //保持していたフィルタ
          const savedFilterModel = sessionStorage.getItem('wa9120_filterModel');
          // 保存されたフィルタモデルがあれば、それを適用
          if (savedFilterModel) {
            const filterModel = JSON.parse(savedFilterModel);
            this.gridOptions.api.setFilterModel(filterModel);
          }
          else{
            this.gridOptions.api.setFilterModel(this.bkgFilter);//フィルタをクリア
          }
        }, 100);

        if (this.isRefreshAndCheckUpdateData == true) {
          setTimeout(() => {
            this.gridHelper.selectedAnimate();
          }, 100);
        }

        this.isRefreshAndCheckNewData = false;
        this.isRefreshAndCheckUpdateData = false;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        this.isRefreshAndCheckNewData = false;
        this.isRefreshAndCheckUpdateData = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  reg() {
    this.router.navigate(['wa9121']);
  }

  regLocashelf() {
    this.router.navigate(['wa9124']);
  }

  upd() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('loca', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa9122']);
  }

  updLocashelf() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }

    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    var shelfcaseId = this.rowData[selectedIndex]['shelfcaseId'];
    if (shelfcaseId === 0) {
      this.errorInfo = '格納什器が設定されていないロケのため、什器単位で修正できません';
      return;
    }

    var whCd = this.rowData[selectedIndex]['whCd'];
    var floorCd = this.rowData[selectedIndex]['floorCd'];
    var areaCd = this.rowData[selectedIndex]['areaCd'];
    var lineCd = this.rowData[selectedIndex]['lineCd'];
    var shelfCd = this.rowData[selectedIndex]['shelfCd'];

    this.gridOptions.api.forEachNode(function (node) {
      if (node.data.whCd === whCd && node.data.floorCd === floorCd && node.data.areaCd === areaCd && node.data.lineCd === lineCd && node.data.shelfCd === shelfCd) {
        node.setSelected(true);
      }
    });

    this.dialogsService.confirm('確認', '什器単位で一括修正します。よろしいですか？').subscribe(res => {
      if (res === true) {
        const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
        sessionStorage.setItem('loca', JSON.stringify(this.rowData[selectedIndex]));
        this.router.navigate(['wa9125']);
      } else {
        this.gridOptions.api.deselectAll();
      }
    });
  }

  del() {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    var isDeleteFromPopWin = false;
    if (this.tabIndex == 0) isDeleteFromPopWin = this.isShowWa9122;
    else isDeleteFromPopWin = this.isShowWa9125;

    const selectIds: number[] = [];

    if (isDeleteFromPopWin) {
      const selectedIndex = this.editNode['id'];
      selectIds.push(this.rowData[selectedIndex]['locaId']);
    } else {
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        selectIds.push(this.gridOptions.api.getSelectedNodes()[i].data['locaId']);
      }
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.locaService
      .postForDel(selectIds)
      .then(outputJson => {
        this.working = false;

        if (outputJson.stockexistserrorFl == 1) {
            var errorMsg = '次のロケーションに在庫が存在するため、削除できません。：';
            errorMsg += outputJson.stockExistsLocaCdList.join(', ');
            if (isDeleteFromPopWin) this.deleteErrorMsgForPopup = errorMsg;
            else this.errorInfo = errorMsg;
            this.isShowDeleteModal = false;
            this.isShowSendLoading = false;
            return;
        } else {
          if (isDeleteFromPopWin) {
            if (this.tabIndex == 0) this.isShowWa9122 = false;
            else this.isShowWa9125 = false;
          }

          this.errorInfo = '';
          this.onSubmit();

          if (!isDeleteFromPopWin) sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました');
          this.isShowDeleteModal = false;
          this.isShowSendLoading = false;
        }
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));

        if (isDeleteFromPopWin) this.deleteErrorMsgForPopup = this.commonService.getErrorMessage(error);
        else this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowDeleteModal = false;
        this.isShowSendLoading = false;
      });
    //}
    //});
  }

  // クライアント帳票出力(ロケラベル)
  printClientReport(reportCd: string) {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.working = false;
      this.errorInfo = '対象を選択して下さい';
      this.isShowSendLoading = false;
      return;
    }
    this.working = true;
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;      
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        selectId: data['locaId']
      };
      selectIds.push(jsonUnit);
    }
    this.clientReportService
      .post(0, reportCd, '', this.updprogramCd, selectIds)
      .then(outputJson => {
        console.log('これからCreateForm呼ぶよ' + JSON.stringify(outputJson));
        //一次テーブルからCSV生成
        this.createFormService.generateCreateformFile(reportCd, outputJson.reporttrnId)
        .then(outputJson => {
          this.gridOptions.api.deselectAll();
          this.working = false;
          this.isShowSendLoading = false;
          this.isShowPrintModal = false;
          const filename = outputJson.pdfFilename
          const url = environment.pdfPath + filename;
          this.openReport(url);
        })
        //CSV生成でエラー
        .catch(error => {
          this.working = false;
          this.isShowSendLoading = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
          console.log(this.commonService.getErrorMessage(error));
        });
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowPrintModal = false;
        this.isShowSendLoading = false;
      });
  }
  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
    //セッションからも削除
    sessionStorage.removeItem('wa9120_filterModel');
    //console.log('sessionからフィルタをクリアしました');
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  onTabChanged(idx) {
    this.tabIndex = idx;

    this.bkgFilter = this.gridOptions.api.getFilterModel();
    if (idx === 1) {
      this.rowData = [];
      setTimeout(() => {
        this.gridOptions.api.setFilterModel(this.bkgFilter);
      }, 200);
    } else {
      this.onSubmit();
    }
    this.errorInfo = '';
    this.gridOptions.api.deselectAll();
    this.toggleGridField();
  }

  toggleGridField() {
    this.gridOptions.columnApi.setColumnVisible('localCd', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('localTx', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('locabarcodeTx', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('layerCd', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('orderCd', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('arrivepriorityNr', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('shippriorityNr', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('mixitemFl', this.tabIndex == 0);
    this.gridOptions.columnApi.setColumnVisible('mixlotFl', this.tabIndex == 0);
  }

  onEditButtonClick(node) {
    this.deleteErrorMsgForPopup = '';
    this.editNode = node;
    sessionStorage.setItem('loca', JSON.stringify(node.data));
    //現時点のフィルタを保持
    this.saveFilterState();
    if (this.tabIndex == 0) this.isShowWa9122 = true;
    else this.isShowWa9125 = true;
  }

  onShowDeleteModal() {
    this.errorInfo = '';
    this.deleteErrorMsgForPopup = '';
    this.isShowDeleteModal = true;
  }

  onShowDeleteModalFrom9122() {
    if (this.editNode == null) {
      return;
    }
    this.isShowDeleteModal = true;
  }

  onClose9122(isRefreshGrid: boolean) {
    this.isShowWa9122 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckUpdateData = true;
      this.gridHelper.prepareSelectedAnimateByNodes([this.editNode]);
      this.onSubmit();
    }
  }

  onClose9125(isRefreshGrid: boolean) {
    this.isShowWa9125 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckUpdateData = true;
      this.gridHelper.prepareSelectedAnimateByNodes([this.editNode]);
      this.onSubmit();
    }
  }

  showLoginView() {
    if (this.tabIndex == 0) {
      this.showWa9121();
    } else {
      this.showWa9124();
    }
  }
  showWa9124() {
    this.isShowWa9124 = true;
  }

  onClose9124(isRefreshGrid: boolean) {
    this.isShowWa9124 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckNewData = true;
      this.onSubmit();
    }
  }

  showWa9121() {
    this.isShowWa9121 = true;
  }

  onClose9121(isRefreshGrid: boolean) {
    this.isShowWa9121 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckNewData = true;
      this.onSubmit();
    }
  }

  showWa9183() {
    this.isShowWa9183 = true;
  }

  onClose9183(isRefreshGrid: boolean) {
    this.isShowWa9183 = false;
    if (isRefreshGrid) this.onSubmit();
  }
   
  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      const popup_window = window.open(url);
      try {
        popup_window.focus();
      } catch (e) {
        (this.errorInfo = 'ポップアップが許可されていません。PDFを開いて良い場合は、「PDFを開く」ボタンを押してください。'), url, 'PDFを開く';
      }
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  /**
   * フィルタ状態をセッションストレージに保存する
   */
  saveFilterState(): void {
    const filterModel = this.gridOptions.api.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
        //console.log('セッションにfilterセット------');
        sessionStorage.setItem('wa9120_filterModel', JSON.stringify(filterModel));
    } else {
        // フィルタが空の場合は保存されている値を削除
        sessionStorage.removeItem('wa9120_filterModel');
    }
  }
    
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9120/wa9120.component.ts